// extracted by mini-css-extract-plugin
export var chevronIcon = "_c7-2";
export var teamName = "_c7-1";
export var teamSwitcherButton = "_c7-0";